export default __webpack_public_path__ + "static/media/kutlamalar.c1e2f86c.jpg";